import { Controller } from '@hotwired/stimulus';

/*
  Permite cerrar una ventana que se abrío previamente usando el componente NewTabButton
*/
/* global Cifra */
export default class extends Controller {
  connect() {
    this.element.querySelector('.centro-externo').addEventListener('change', () => {
      this.onCentroExternoChanged();
    });

    // Conecto a los eventos del modal
    Cifra.Channels.ModalHtml.on('form:success', (view, data) => {
      if (view.$el.hasClass('centro-externo-btn')) {
        this.#actualizarSelectCentros(data.model);
      }
    }).on('form:success:delete', (view, data) => {
      if (view.$el.hasClass('centro-externo-btn')) {
        this.#deleteCentroExterno(data.model.id);
      }
    });
    this.onCentroExternoChanged();
  }

  onCentroExternoChanged() {
    // Cambiamos el link a la edición del centro externo
    const boton = this.element.querySelector('#editar-centro');
    const id = this.element.querySelector('select').value;
    const urlTemplate = this.element.querySelector('#crear-centro').getAttribute('href').replace('new', '');
    let disable = true;
    let url = '#';
    if (id) {
      url = `${urlTemplate}${id}/edit`;
      disable = false;
    }
    boton.disabled = disable;
    boton.setAttribute('href', url);
  }

  #actualizarSelectCentros(model) {
    const select = this.element.querySelector('.centro-externo');
    const option = select.querySelector(`option[value="${model.id}"]`);
    if (option) {
      option.innerText = model.nombre;
    } else {
      select.add(new Option(model.nombre, model.id));
    }
    select.value = model.id;
    this.onCentroExternoChanged();
  }

  #deleteCentroExterno(id) {
    const select = this.element.querySelector('.centro-externo');
    const option = select.querySelector(`option[value="${id}"]`);
    option.remove();
    this.onCentroExternoChanged();
  }
}
